import { createReducer } from "typesafe-actions";

import BoundaryLegendsUiState from "@app/store/boundaryLegendsUi/BoundaryLegendsUiState";

import {
  BoundaryLegendsActions,
  hideBoundaryLegendDrawer,
  hideCreateBoundaryLegendWizard,
  showBoundarySettingsPopover,
  showCreateBoundaryLegendWizard,
  showUpdateBoundaryLegendDrawer,
} from "./actions";

export const boundaryLegendsInitialState: BoundaryLegendsUiState = {};

const boundaryLegends = createReducer<BoundaryLegendsUiState, BoundaryLegendsActions>(
  boundaryLegendsInitialState
)
  .handleAction(showCreateBoundaryLegendWizard, (state, { payload }) => ({
    ...state,
    boundaryLegend: undefined,
    boundaryType: "boundaryType" in payload ? payload.boundaryType : payload.boundaryLegend.view,
    sampleLegend: "boundaryLegend" in payload ? payload.boundaryLegend : undefined,
  }))
  .handleAction(hideCreateBoundaryLegendWizard, (state) => ({
    ...state,
    boundaryType: undefined,
    sampleLegend: undefined,
  }))
  .handleAction(showUpdateBoundaryLegendDrawer, (state, { payload }) => ({
    ...state,
    boundaryLegend: payload,
  }))
  .handleAction(hideBoundaryLegendDrawer, (state) => ({
    ...state,
    boundaryLegend: undefined,
  }))
  .handleAction(showBoundarySettingsPopover, (state, { payload }) => ({
    ...state,
    boundaryLegendSettingsPopover: payload,
  }));

export default boundaryLegends;
